import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Share from './share';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { channel, downloads, docData } = this.props.content;
        const title = channel.title ? `${channel.title}频道` : '大风号';

        return (
            <div className={styles.header}>
                <a href="//i.ifeng.com" className={styles.logo}>
                    手机凤凰网
                </a>
                <h2 className={styles.channelName}>
                    <a href={channel.url}>{title}</a>
                </h2>
                <Share docData={docData} content={downloads} />
            </div>
        );
    }
}

export default errorBoundary(Header);
